import type { App, AppCreate, AppUpdate, DataResponse, PaginatedResponse } from "@/types";
import { api } from "../api";

export const appService = {
  list: () => api.get<PaginatedResponse<App>>("/apps"),
  get: (appId: string) => api.get<DataResponse<App>>(`/apps/${appId}`),
  create: (data: AppCreate) => api.post<DataResponse<App>>("/apps", data),
  update: (appId: string, data: AppUpdate) => api.put<DataResponse<App>>(`/apps/${appId}`, data),
  delete: (appId: string) => api.delete<{ message: string }>(`/apps/${appId}`),
};
